import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.BaseballCardModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.BaseballCardModal = (function (parent) {
    __extends(BaseballCardModal, parent);
        
    function BaseballCardModal(config) {
        var modal = BaseballCardModal.__super__.constructor.call(this, "baseball-card");
        var baseUrl = config.baseUrl || '';

        this.callbackok = null;
        this.callbackcancel = null;

        this.Close.off();//remove existing handler, have our own

        eventHandlers(this);
        var loaderUrl = HSN.Instance().UseFullyQualifiedUrls() ? baseUrl + '/assets/img/spinner-l-d8d9d9.gif': '/assets/img/spinner-l-d8d9d9.gif';
        var loader = $('<div id="loader" class="loader"><img alt="" src="' + loaderUrl + '"></div>');
        loader.appendTo(this.Root);

        return modal;
    }

    function eventHandlers(modal) {

        $(modal.Content).on('click', '#baseball-card-modal', function (e) {
            $(this).off('click');
            $(modal.Close).click();
            return false;
        });

        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });
    }

    function closeModal(modal) {
        $('.video-flash').css('visibility', 'visible');

        modal.Hide();

        cmCreateManualLinkClickTag('cm_re=cm_re=Arcade-_-Profile-_-Close&cm_sp=cm_re=Arcade-_-Profile-_-Close', 'CloseArcadeDrawer');
    }

    callbackok: null;
    callbackcancel: null;

    BaseballCardModal.prototype.SetOkCallback = function (callbackOk) {
        this.callbackok = callbackOk;
    };
    BaseballCardModal.prototype.SetCancelCallback = function (callbackCancel) {
        this.callbackcancel = callbackCancel;
    };
    BaseballCardModal.prototype._show = function (name, baseUrl) {
        $('.video-flash').css('visibility', 'hidden');
        var host = baseUrl || '';

        this.Center();
            
        var scope = this;
        var successCallback = function(data) {
            scope.Root.removeClass('loading');

            if (data != null && data != "") {
                scope.Content.showHtml(
                    data,
                    0,
                    function() {
                        scope.Center();
                        scope.Content.animate({ opacity : 1 });
                        //handle any tooltips loaded
                        if(!Modernizr.touchevents) {
                            HSN.Tooltip(scope.Content.find("[data-tooltip]"));
                        }
                    },
                    function() {
                        //scope.Center();
                    }
                );
            }
            else {
                $('#modal-mask').remove();
            }
        };

        var failureCallback = function(xhr, status, error) {
            alert("Unfortunately there was an error attempting to load the content, please try again.");
            $('#modal-mask').remove();
        }

        var url = (name == null || name == "") ? '/baseballcard' : "/baseballcard/" + name;
        url = HSN.Instance().UseFullyQualifiedUrls() ? host + url : url;
        
        var arcadeObjectName = HSN.GetHsnArcadeObjectName();
        //Arcade object existence indicates that we are on the arcade wrapper page
        if(arcadeObjectName !== null) {
            window.location = host + "/profile/" + name;
        }
        else {
            $.ajax(url, {
                        cache: false,
                        context: this,
                        dataType: 'html',
                        success: successCallback,
                        error: failureCallback
                    }
                )
                .done(function () {
                    $('#modalPopup').focus();
                }); 
        }           
    };

    return BaseballCardModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/BaseballCardModal.js